import { render, staticRenderFns } from "./details-dialog.vue?vue&type=template&id=a699eff6"
import script from "./details-dialog.vue?vue&type=script&lang=ts"
export * from "./details-dialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports